var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.818 19.15H1.312a.82.82 0 010-1.64h1.686V1.624a.82.82 0 01.82-.82h13.364a.82.82 0 01.82.82v15.884h1.686a.82.82 0 010 1.64H3.818zm4.191-1.64H4.64V2.444H16.36V17.51h-3.37v-4.19a.82.82 0 00-.82-.821H8.83a.82.82 0 00-.82.82v4.191zm1.64 0h1.701v-3.372h-1.7v3.371zM7.16 4.145a.82.82 0 100 1.64h1.67a.82.82 0 100-1.64H7.16zm4.191.82a.82.82 0 01.82-.82h1.67a.82.82 0 010 1.64h-1.67a.82.82 0 01-.82-.82zm-4.19 2.52a.82.82 0 100 1.641h1.67a.82.82 0 100-1.64H7.16zm4.19.82a.82.82 0 01.82-.82h1.67a.82.82 0 010 1.641h-1.67a.82.82 0 01-.82-.82z",
    fill: "#B7B8EB"
  })));
}
export default SvgBuilding;